import { FieldValues } from "react-hook-form";

import { normalizePhoneNumber } from "./phoneUtils";

export const mapFormToRequestBody = async (
  props: FieldValues,
  { editMode }: { editMode: boolean }
) => ({
  name: props.name,
  email: props.email,
  scope: props.scope.replace(/\s+/g, ""),
  ...(editMode
    ? { accountIds: props.accountIds }
    : { accountId: props.accountIds }),
  defaultAccount: props.defaultAccount,
  analyticsTabEnabled: props.analyticsTabEnabled,
  contractsLibraryEnabled: props.contractsLibraryEnabled,
  contractsOnlyMode: props.contractsOnlyMode,
  reportsOnlyMode: props.reportsOnlyMode,
  // Report access applies to any hospital-staff user (reportsOnlyMode only toggles tab
  // visibility, not data). Always sent so the selection is preserved as-is — including across a
  // role change to SuperAdmin, where grants are kept but no longer restrict what they see.
  reportAccessIds: props.reportAccessIds || [],
  mfaChannel: props.mfaChannel || "email",
  mfaPhoneNumber: normalizePhoneNumber(props.mfaPhoneNumber),
});
